// extracted by mini-css-extract-plugin
export default {"wrap":"InTaxBaseComponent_wrap__Wqt-U"};